

          var bloodhound = new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.whitespace,
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          remote: {
            url: "/search-live?q=%QUERY%",
            wildcard: '%QUERY%'
          },
        });

        $('#search').typeahead({
          hint: true,
          highlight: true,
          minLength: 1
        }, {
          name: 'users',
          source: bloodhound,
          display: function(data) {
            return data.name  //Input value to be set when you select a suggestion.
          },
          templates: {
            empty: [
              '<div class="list-group-item">Aucun résultat.</div>'
            ],
            suggestion: function(data) {
            return '<a class="d-block" href="/m/'+data.slug+'"><div class="list-group-item">' + data.name + '</div></a>'
            }
          }
        });
